import { createAction } from 'Lib/reduxUtils';

import type { ValidModalType } from 'Containers/ModalManager/types';

import { CLOSE_MODAL, OPEN_MODAL } from './constants';
import type { Params } from './types';

export const openModal = createAction(OPEN_MODAL, (type: ValidModalType, params?: Params) => ({
  type,
  params,
}));
export const closeModal = createAction(CLOSE_MODAL);
